import BaseService from '../../BaseService.js';

export default class KontaktService extends BaseService {

  constructor() {
    super('kontakt')
  }
}
